import type { PropAttributeTable, PropMaterialOverrides } from "building-types/props/propTypes";

/**
 * Merges catalog material overrides with prop-specific overrides.
 * Catalog overrides are applied first, then prop overrides take precedence.
 */
export function mergePropMaterialOverrides(
  propSrc: string,
  propMaterialOverrides: PropMaterialOverrides | undefined,
  propAttributeTable: PropAttributeTable,
): PropMaterialOverrides {
  const catalogOverrides = propAttributeTable[propSrc]?.materialOverrides;
  return {
    ...catalogOverrides,
    ...propMaterialOverrides,
  };
}

/**
 * Resolves useExteriorPalette from prop and catalog attributes.
 * Priority: isExterior > prop.useExteriorPalette > catalog.useExteriorPalette > false
 */
export function resolveUseExteriorPalette(
  propSrc: string,
  isExterior: boolean | undefined,
  propUseExteriorPalette: boolean | undefined,
  propAttributeTable: PropAttributeTable,
): boolean {
  const catalogUseExteriorPalette = propAttributeTable[propSrc]?.useExteriorPalette;
  return (isExterior || propUseExteriorPalette) ?? catalogUseExteriorPalette ?? false;
}
